// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"f308d058","230":"3986bd8f","277":"389a57d9","337":"f0cce142","368":"7e40aebd","531":"5ee1c264","545":"de8f01ee","746":"5eac64f2","971":"c9837e30"}[chunkId] + ".chunk.js";
};